import { ObjectUtils } from './object-utils.component';

export class StringUtils {
  static getInitials = (name: string, glue: boolean = true): string => {
    if (ObjectUtils.isNullOrUndefined(name)) {
      return '';
    }

    const initialsArray: string[] = name.replace(/[^a-zA-Z- ]/g, '').match(/\b\w/g) || [];
    if (initialsArray.length > 0) {
      return glue ? initialsArray.slice(0, 2).join('').toUpperCase() : initialsArray.slice(0, 2).join(' ').toUpperCase();
    } else {
      return '';
    }
  }

  static isNullOrWhiteSpace = (text: string): boolean => {
    if (text) {
      text = text.toString().trim();
    }
    return ObjectUtils.isNullOrUndefined(text) || text === '';
  }

  static removeEndLineChars = (text: string): string => {
    if (ObjectUtils.isNullOrUndefined(text)) {
      return text;
    }
    return text.replace(/(\r\n|\n|\r)/gm, '');
  }

  static parseIntString = (number: number): string => {
    return number < 10 ? `0${number}` : number.toString();
  }

  static replaceToApostrophe = (text: string | null | undefined): string | null | undefined => {
    if (text === null || text === undefined) {
      return text; // Ahora es válido porque el tipo de retorno lo permite
    }
    return text.replace(/&#39;/g, "'");
  }

  static formatAsHTML = (messagesOrdered: { [key: string]: { message: string }[] }): string => {
    const groups = Object.keys(messagesOrdered).map((key) => {
      const template = '<div>' +
        '<ul>' +
        messagesOrdered[key].map((message) => '<li>' + message.message + '</li>').join('') +
        '</ul>' +
        '</div>';
      return template;
    });

    return groups.join('');
  }
}
